
const searchBlueSVG = `
<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="29.371px" height="30.272px" viewBox="0 0 29.371 30.272" enable-background="new 0 0 29.371 30.272" xml:space="preserve">
<g id="Layer_1">
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
	<g>
		<g>
			<path fill="#14ACE3" d="M20.4,19.761c1.936-2.095,3.143-4.901,3.143-7.989C23.543,5.292,18.27,0,11.771,0S0,5.292,0,11.771
				c0,6.48,5.273,11.771,11.771,11.771c2.646,0,5.077-0.87,7.049-2.342l8.753,8.752c0.213,0.213,0.479,0.32,0.746,0.32
				s0.551-0.107,0.745-0.32c0.409-0.407,0.409-1.082,0-1.509L20.4,19.761z M2.131,11.771c0-5.307,4.314-9.641,9.641-9.641
				c5.31,0,9.642,4.314,9.642,9.641s-4.315,9.641-9.642,9.641S2.131,17.078,2.131,11.771z"/>
		</g>
	</g>
</g>
</svg>

`;

export default searchBlueSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/searchBlueSVG.js